import { TextField } from "@buildblockinc/buildblock-design-system";
import { ChevronLeft, Search } from "lucide-react";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onBack: () => void;
  placeholder?: string;
  disabled?: boolean;
}

export function SearchBar({
  value,
  onChange,
  onBack,
  placeholder = "Enter to add or search",
  disabled = false,
}: SearchBarProps) {
  return (
    <TextField disabled={disabled}>
      <TextField.Input
        prefix={
          <button type="button" onClick={onBack} aria-label="Go back">
            <ChevronLeft width={20} height={20} className="text-gray-1000" />
          </button>
        }
        suffix={
          <button type="button" aria-label="Search">
            <Search width={16} height={16} className="text-gray-900" />
          </button>
        }
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </TextField>
  );
}
